import styled from 'styled-components';

export const StyledInput = styled.input`
  font-size: 15px;
  font-weight: 600;
  border: 1px solid ${({ theme }) => theme.palette.border};
  border-radius: 4px;
  padding: 4px 8px;
  outline: none;

  &:focus {
    border-color: #7c3aed;
  }
`;
